import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { environment } from "../../../../environments/environment";
import { ServerConfigsStore } from "../../../stores/serverConfigs/serverConfigs.store";

@Component({
    selector: "app-nav",
    standalone: true,
    imports: [CommonModule, MatToolbarModule],
    templateUrl: "./nav.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    
})
export class NavComponent {public env = environment; public serverConfigsStore = inject(ServerConfigsStore)}

